<template>
  <div id="inside" style="" :style="largura > 500 ? '' : 'min-height: 480px;'">
    <div v-bind:class="largura > 500 ? 'container' : ''">
      <nav class="navbar3 navbar-light navbar-expand" v-if="!loading">
        <button class="navbar-toggler navbar-toggler-right border-0" type="button" data-toggle="collapse"
          data-target="#navbar3">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse text-center justify-content-center" id="navbar3" style="width: 100%">
          <ul class="navbar-nav justify-content-between">
            <li v-bind:class="[
              this.currentPage !== 'meusAcordos'
                ? 'nav-item border-bottom border-info mx-5 mb-2'
                : 'nav-item mx-5',
            ]">
              <a class="nav-link active" @click="home" style="cursor: pointer">Propostas</a>
            </li>
            <li v-bind:class="[
              this.currentPage === 'meusAcordos'
                ? 'nav-item border-bottom border-info mx-5 mb-2'
                : 'nav-item mx-5',
            ]">
              <a class="nav-link" @click="meusAcordos" style="cursor: pointer">Acordos
                <span class="badge badge-primary badge-pill" v-if="agreements.length">{{ agreements !== null ?
                  agreements.length : 0 }}</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>
      <div v-if="!loading && !isRedirectingToAcordos">
      <div class="row d-flex justify-content-center px16 my16">
        <div class="px-0 col-lg-12">
          <div class="stepper-wrapper">
            <div class="stepper-item active">
              <div class="step-counter">1</div>
            </div>
            <div class="stepper-item">
              <div class="step-counter">2</div>
            </div>
            <div class="stepper-item">
              <div class="step-counter">3</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-12 mt-3">
        <div class="row">
          <div class="col-lg-12">
            <h5 class="mb-1 text-primary" style="font-weight: bold">
              Olá, {{ user.FullName ? user.FullName : user.DocNumber }}!
            </h5>
            <h6 class="mb-0" style="color: #3a4148; font-weight: 600" v-if="contracts.length > 0">
              Contratos disponíveis
            </h6>
            <div v-if="contracts.length <= 0 && agreements !== null && agreements.length > 0">
              <h6 class="mb-0 mt-3" style="color: #3a4148; font-weight: 600">
                Acordos em aberto
              </h6>

              <button class="btn btn-primary mt-3 btn-block text-white" @click="meusAcordos"
                :style="largura > 500 ? 'max-width: 30%' : ''">
                Você tem
                {{ agreements !== null ? agreements.length : 0 }}
                {{ agreements !== null ? agreements.length === 1 ? 'acordo' : 'acordos' : '' }}
              </button>
            </div>

            <p v-if="contracts.length > 0" class="mb-0" style="color: #3a4148; font-weight: 400; font-style: italic">
              Veja aqui as informações disponíveis para negociar seus débitos
            </p>
            <p v-if="contracts.length <= 0 && (!agreements || agreements.length === 0) && !loading" class="mb-0 mt-4 text-center p-5" style="
                color: #3a4148;
                font-weight: 400;
                font-style: italic;
                background-color: #fff;
                border-radius: 10px;
              ">
              No momento não existe contratos para serem negociados.
            </p>
          </div>
        </div>
      </div>

      <!-- TRIBANCO -->
      <!-- <div v-if="contracts.length && contracts[0].company === 'TRICARD'"> -->
      <div v-if="
        contracts.length && contracts[0].company === 'TRIBANCO' && !loading
      " class="container">
        <div class="row">
          <div v-for="(contract, key, index) in contractsTribanco" :key="`${key}-${index}`" v-bind:class="largura > 500
              ? 'col-lg-4 col-md-6 col-12 mb-1'
              : 'col-lg-4 col-md-6 col-12 mb-1'
            ">
            <div class="card" :style="largura < 500 ? '' : ''">
              <div class="card-body pb-3">
                <h6 style="font-weight: 600">
                  Contrato {{ contract.contrato }}
                </h6>
                <p class="mb-2 text-muted" style="font-size: 0.8rem">
                  Produto {{ contract.produto }}
                </p>

                <!-- hasOffers true: card resumido → negocia em tela separada -->
                <template v-if="contract.hasOffers !== false">
                  <div class="discount-highlight d-flex align-items-center justify-content-center"
                    v-if="hasRealDiscount(contract)">
                    <span class="melhor-oferta-badge mt-1" style="text-transform: none !important; font-size: 12pt">
                      <svg width="17" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg"
                        style="margin-right: 5px; margin-bottom: 4px">
                        <path
                          d="M3.16172 6.41295C4.15428 4.93822 5.09363 3.53429 5.20824 1.7642C5.23484 1.35961 5.20005 0.950976 5.21438 0.546385C5.22052 0.360273 5.09568 0.101335 5.35354 0.0123249C5.54387 -0.0524096 5.66461 0.153932 5.78945 0.271263C7.14834 1.55179 8.44173 2.89099 9.54685 4.39809C10.8321 6.14997 11.8471 8.02727 11.9843 10.2303C12.1725 13.2283 10.6745 16.2384 7.38982 16.8838C3.29884 17.6889 -0.444237 14.1932 0.0428338 10.0785C0.255671 8.28621 0.904417 6.69617 1.96042 5.24976C2.07707 5.08994 2.17326 4.83505 2.39837 4.86944C2.63168 4.90383 2.6194 5.17693 2.68284 5.36506C2.7647 5.6058 2.8527 5.84248 2.94889 6.07714C2.98572 6.16615 3.05121 6.24303 3.16172 6.41295ZM5.92861 8.01513C5.94908 9.21879 5.57252 10.0442 5.04656 10.8109C4.9381 10.9686 4.78666 11.3409 4.5554 10.9808C4.1461 10.3415 4.03559 10.8473 3.86777 11.1204C3.55465 11.6261 3.37251 12.1885 3.31521 12.7711C3.19242 13.999 3.58331 15.0328 4.64954 15.7388C5.64005 16.3942 6.68582 16.4286 7.70089 15.8197C8.75894 15.1845 9.12732 14.1427 9.02704 13.0017C8.84694 10.9403 7.49215 9.54651 5.92861 8.01513Z"
                          fill="white" />
                      </svg>&nbsp;
                      Oferta disponível para este contrato
                    </span>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-2 mt-2"
                    v-if="contract.atSightOffer || (contract.offers || []).length > 0">
                    <div>
                      <p class="mb-0 de-por" v-if="hasRealDiscount(contract)">
                        de
                        <strike>R$
                          {{ contract.offers[0].RETORNO.VALORPARCELAR }}</strike>
                        por
                      </p>
                      <h6 class="m-0" style="font-weight: bold; font-family: Cabin" v-if="contract.atSightOffer">
                        À vista R$
                        {{ contract.atSightOffer }}
                      </h6>
                      <p class="mb-1 parcelas" v-if="!contract.isProductEMP && contract.maxInstallmentNumber > 0">
                        ou em até
                        {{ contract.maxInstallmentNumber }} parcelas de R${{
                          contract.maxInstallmentValue
                        }}
                      </p>
                    </div>
                    <div class="text-right ml-2" v-if="hasRealDiscount(contract)">
                      <span class="percents">
                        <span class="discount-percentage" style="font-weight: 500 !important">
                          <img src="/img/vector-arrow-down.svg" alt="Desconto" />
                          {{ contract.discountPercentage }}%</span>
                      </span>
                    </div>
                  </div>
                  <p class="" style="font-weight: 600; cursor: pointer" @click="toggleCombo(contract)">
                    Ver detalhes do contrato
                    <i class="fa fa-chevron-down" v-if="!isComboOpen(contract)"></i>
                    <i class="fa fa-chevron-up" v-else></i>
                  </p>
                  <div class="contract-item" v-if="isComboOpen(contract)">
                    <div class="table-responsive" :style="(contract.parcelas || []).length > 4
                        ? 'max-height: 14rem; overflow-y: auto;'
                        : 'overflow-y: auto;'
                      ">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Parcela</th>
                            <th>Vencimento</th>
                            <th>Valor</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(parc, k) in contract.parcelas" :key="k">
                            <td>{{ k + 1 }}/{{ contract.parcelas.length }}</td>
                            <td>
                              {{
                                formatData(
                                  parc.vencimento,
                                  "YYYY-MM-DD",
                                  "DD/MM/YYYY"
                                )
                              }}
                            </td>
                            <td>{{ parc.valor }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <button class="btn btn-primary btn-block text-white mt-3"
                    @click="abrirPropostasTribanco(contract)"
                    style="cursor: pointer !important"
                    :disabled="loading">
                    NEGOCIAR
                  </button>
                </template>

                <!-- hasOffers false: seleção e negociação no próprio card -->
                <template v-else>
                  <p class="" style="font-weight: 600; cursor: pointer" @click="toggleCombo(contract)">
                    Ver detalhes do contrato
                    <i class="fa fa-chevron-down" v-if="!isComboOpen(contract)"></i>
                    <i class="fa fa-chevron-up" v-else></i>
                  </p>
                  <div class="contract-item" v-if="isComboOpen(contract)">
                    <div class="contract-intern">
                      <label class="checkbox-container mb-0">
                        <input type="checkbox" :checked="isContractFullySelected(contract)" @change="
                          toggleContrato(contract, $event.target.checked)
                          " :disabled="loadingOptionsInstallments" />
                        <span class="checkmark"></span>
                        <span class="contract-text">Contrato {{ contract.contrato }}</span>
                      </label>
                      <i class="fa fa-chevron-down" v-if="!isIndividualOpen(contract)"
                        @click="toggleIndividual(contract)"></i>
                      <i class="fa fa-chevron-up" v-else @click="toggleIndividual(contract)"></i>
                    </div>
                    <div class="table-responsive" v-if="isIndividualOpen(contract)" :style="contract.parcelas.length > 4
                        ? 'max-height: 14rem; overflow-y: auto;'
                        : 'overflow-y: auto;'
                      ">
                      <table class="table">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Parcela</th>
                            <th>Vencimento</th>
                            <th>Valor</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(parc, k) in contract.parcelas" :key="k">
                            <td>
                              <input type="checkbox" class="checkmark" style="cursor: pointer" :disabled="!canToggleParcela(contract, k) ||
                                loadingOptionsInstallments
                                " :checked="!!parc.selected" @change="toggleParcela(contract, k)" />
                            </td>
                            <td>{{ k + 1 }}/{{ contract.parcelas.length }}</td>
                            <td>
                              {{
                                formatData(
                                  parc.vencimento,
                                  "YYYY-MM-DD",
                                  "DD/MM/YYYY"
                                )
                              }}
                            </td>
                            <td>{{ parc.valor }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <p class="text-info mb-1">Escolha o vencimento</p>
                  <div class="form-group m-0 mx-0 p-0">
                    <div class="form-group">
                      <select id="DiaSelect" class="form-control" v-model="dueDate" :disabled="loading"
                        @change="onDueDateChangeTribanco(contract)">
                        <option v-for="(date, dateIndex) in dueDates" :key="`date-${dateIndex}-${date}`">
                          {{ date }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <p class="emp-total mb-2 mt-3">
                    Total selecionado
                    <strong>R$ {{ selectedTotal(contract) }}</strong>
                  </p>
                  <button class="btn btn-primary btn-block text-white" @click="negociarTribanco(0, contract)"
                    style="cursor: pointer !important"
                    :disabled="loadingOptionsInstallments || selectedCount(contract) === 0">
                    NEGOCIAR PARCELAS SELECIONADAS
                  </button>
                  <hr />
                  <button class="btn btn-secondary mb-4" @click="openModalEntradaTribanco()"
                    style="cursor: pointer !important" :disabled="loadingOptionsInstallments">
                    Monte sua proposta
                  </button>
                  <ProgressLoading v-bind:loading="loadingOptionsInstallments &&
                    contractChooseParcOptions === contract.contrato
                    " />
                </template>
              </div>
            </div>
          </div>
        </div>
        <div v-if="contractsUnica.length" class="row">
          <div class="col-lg-4 col-md-6 col-12 mb-1">
            <div class="card">
              <div class="card-body pb-3">
                <h6 style="font-weight: 600" class="mb-3">
                  Mensalidade POS Única
                </h6>
                <h6 style="font-weight: 600">
                  À vista R$ {{ unicaSelectedTotal }}
                </h6>
                <div class="form-group mt-3">
                  <label style="font-size: 0.85rem">Escolha o vencimento</label>
                  <select class="form-control" v-model="unicaDueDate">
                    <option
                      v-for="(date, dateIndex) in unicaDueDates"
                      :key="`unica-date-${dateIndex}-${date}`"
                    >
                      {{ date }}
                    </option>
                  </select>
                </div>
                <button
                  class="btn btn-primary btn-block text-white"
                  style="cursor: pointer !important"
                  :disabled="unicaSelectedCount === 0"
                  @click="negociarUnica"
                >
                  PAGAR À VISTA R$ {{ unicaSelectedTotal }}
                </button>
                <hr class="unica-divider" />
                <div class="unica-select">
                  <p class="unica-select-caption">
                    Selecione os contratos que deseja negociar
                  </p>
                  <div class="unica-table">
                    <span class="unica-head"></span>
                    <span class="unica-head">Contrato</span>
                    <span class="unica-head">Vencimento</span>
                    <span class="unica-head">Valor</span>
                    <template v-for="contract in contractsUnica">
                      <label
                        class="unica-check"
                        :key="`unica-check-${contract.contrato}`"
                      >
                        <input
                          type="checkbox"
                          :checked="isUnicaContractSelected(contract)"
                          @change="toggleContratoUnica(contract)"
                        />
                        <span></span>
                      </label>
                      <span
                        class="unica-cell"
                        :key="`unica-contrato-${contract.contrato}`"
                      >{{ contract.contrato }}</span>
                      <span
                        class="unica-cell"
                        :key="`unica-venc-${contract.contrato}`"
                      >{{ unicaDueLabel(contract) }}</span>
                      <span
                        class="unica-cell"
                        :key="`unica-valor-${contract.contrato}`"
                      >R$ {{ unicaContractValue(contract) }}</span>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- TRICARD -->
      <div v-if="contracts.length && contracts[0].company === 'TRICARD'" class="container">
        <div class="row">
          <div v-bind:class="largura > 500
              ? 'col-lg-4 col-md-6 col-12 mb-1'
              : 'col-lg-4 col-md-6 col-12'
            ">
            <div>
              <div class="card" :style="largura < 500 ? '' : ''" v-for="(contract, i) in contracts"
                :key="contract.contrato || i">
                <div class="card-body">
                  <div>
                    <p>Contrato {{ contract.contrato }}</p>
                    <div class="discount-highlight d-flex align-items-center justify-content-center">
                      <span class="melhor-oferta-badge mt-1">
                        <svg width="17" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg"
                          style="margin-right: 5px; margin-bottom: 4px">
                          <path
                            d="M3.16172 6.41295C4.15428 4.93822 5.09363 3.53429 5.20824 1.7642C5.23484 1.35961 5.20005 0.950976 5.21438 0.546385C5.22052 0.360273 5.09568 0.101335 5.35354 0.0123249C5.54387 -0.0524096 5.66461 0.153932 5.78945 0.271263C7.14834 1.55179 8.44173 2.89099 9.54685 4.39809C10.8321 6.14997 11.8471 8.02727 11.9843 10.2303C12.1725 13.2283 10.6745 16.2384 7.38982 16.8838C3.29884 17.6889 -0.444237 14.1932 0.0428338 10.0785C0.255671 8.28621 0.904417 6.69617 1.96042 5.24976C2.07707 5.08994 2.17326 4.83505 2.39837 4.86944C2.63168 4.90383 2.6194 5.17693 2.68284 5.36506C2.7647 5.6058 2.8527 5.84248 2.94889 6.07714C2.98572 6.16615 3.05121 6.24303 3.16172 6.41295ZM5.92861 8.01513C5.94908 9.21879 5.57252 10.0442 5.04656 10.8109C4.9381 10.9686 4.78666 11.3409 4.5554 10.9808C4.1461 10.3415 4.03559 10.8473 3.86777 11.1204C3.55465 11.6261 3.37251 12.1885 3.31521 12.7711C3.19242 13.999 3.58331 15.0328 4.64954 15.7388C5.64005 16.3942 6.68582 16.4286 7.70089 15.8197C8.75894 15.1845 9.12732 14.1427 9.02704 13.0017C8.84694 10.9403 7.49215 9.54651 5.92861 8.01513Z"
                            fill="white" />
                        </svg>&nbsp;MELHOR OFERTA</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mb-2 mt-2"
                      v-if="contract.offers.length > 0">
                      <div v-for="(offer, j) in [contract.offers[0]]" :key="j">
                        <div>
                          <p class="mb-0 de-por">
                            de
                            <strike>R$ {{ offer.RETORNO.VALORPARCELAR }}</strike>
                            por
                          </p>
                          <h6 class="m-0" style="font-weight: bold; font-family: Cabin">
                            À vista R$
                            {{ contract.atSightOffer }}
                          </h6>

                          <p class="mb-1 parcelas">
                            ou em até
                            {{ contract.maxInstallmentNumber }} parcelas de R$
                            {{ contract.maxInstallmentValue }}
                          </p>
                        </div>
                      </div>
                      <div class="text-right ml-2">
                        <span class="percents">
                          <span class="discount-percentage" style="font-weight: 500 !important">
                            <img src="/img/vector-arrow-down.svg" alt="Desconto" />
                            {{ contract.discountPercentage }}%</span>
                        </span>
                      </div>
                    </div>
                    <!-- À VISTA -->
                    <p class="" style="font-weight: 600; cursor: pointer"
                      @click="openCloseContractsDetailsIndividual()">
                      Detalhes do contrato
                      <i class="fa fa-chevron-down fa-fw grey01 d-inline-block"
                        v-if="!openContractDetailsIndividual"></i>
                      <i class="fa fa-chevron-up fa-fw grey01 d-inline-block" v-if="openContractDetailsIndividual"></i>
                    </p>
                    <div class="contract-item" v-if="openContractDetailsIndividual">
                      <div class="table-responsive">
                        <table class="table">
                          <thead>
                            <tr>
                              <th>Parcela</th>
                              <th>Vencimento</th>
                              <th>Valor</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(parc, k) in contract.parcelas" :key="k">
                              <td>
                                {{ k + 1 }}/{{ contract.parcelas.length }}
                              </td>
                              <td>
                                {{
                                  formatData(
                                    parc.vencimento,
                                    "YYYY-MM-DD",
                                    "DD/MM/YYYY"
                                  )
                                }}
                              </td>
                              <td>{{ parc.valor }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <p class="text-info mb-1 mt-2">Escolha o vencimento</p>
                    <div class="form-group m-0 mx-0 p-0">
                      <div class="form-group">
                        <select id="DiaSelect" class="form-control" v-model="dueDate"
                          @change="updateOffers({ issuer: 'TRICARD' })">
                          <option v-for="(date, dateIndex) in dueDates" :key="`date-${dateIndex}-${date}`">
                            {{ date }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <button class="btn btn-primary btn-block text-white" @click="resumoAcordoTricard(contract, false)"
                      style="cursor: pointer !important">
                      PAGAR À VISTA R$
                      {{ contract.atSightOffer }}
                    </button>
                    <p class="mb-1 text-center mb-2 mt-3" v-if="contract.offers.length > 0">
                      Ou escolha uma das opções disponíveis
                    </p>
                    <div v-if="contract.offers.length > 0">
                      <div class="col-12 pr-1 pl-1" v-for="(installment1, key3, index3) in contract.offers"
                        :key="`${key3}-${index3}`" :disabled="loading">
                        <div class="preco-parcelado-box" v-if="installment1.INSTALLMENTnUMBER > 0"
                          @click="resumoAcordoTricard(contract, installment1)">
                          <span class="parcela-texto">Entrada + {{ installment1.INSTALLMENTnUMBER }}x R$
                            {{ installment1.PARCELAS[0].PAGO }}</span>
                          <div class="badge-desconto">
                            <i class="fa fa-arrow-down"></i>&nbsp;{{
                              (
                                ((parseFloat(
                                  installment1.RETORNO.VALORPARCELAR.replace(
                                    /\./g,
                                    ""
                                  ).replace(",", ".")
                                ) -
                                  parseFloat(
                                    installment1.RETORNO.VALORTOTAL.replace(
                                      /\./g,
                                      ""
                                    ).replace(",", ".")
                                  )) /
                                  parseFloat(
                                    installment1.RETORNO.VALORPARCELAR.replace(
                                      /\./g,
                                      ""
                                    ).replace(",", ".")
                                  )) *
                                100
                              ).toFixed(2)
                            }}%
                          </div>
                          <div class="badge-seta">
                            <i class="fa fa-arrow-right"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="text-center mt-1" v-if="contract.offers.length > 0">
                      <a @click="showMoreOptions(contract, 'TRICARD')" :disabled="!canShowMore"
                        style="text-decoration: underline; cursor: pointer">Mostrar mais opções</a>
                    </div>
                    <hr />
                    <button class="btn btn-secondary mb-4" @click="openModalEntradaTricard()"
                      style="cursor: pointer !important">
                      Monte sua proposta
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <ProgressLoading v-bind:loading="loadingOptionsInstallments" />
          </div>
        </div>
      </div>

      <!-- MODAIS -->

      <!-- TRIBANCO -->
      <div class="modal fade" id="entrada-tribanco">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Monte sua proposta</h5>
              <button type="button" @click="closeModalEntradaTribanco()">
                <span style="font-size: 12pt">×</span>
              </button>
            </div>
            <div class="modal-body pt-0">
              <form class="mb-0">
                <div class="form-group my-0">
                  <div class="form-group mb-1">
                    <label>Como deseja pagar?</label>
                    <div class="radio-group">
                      <label class="radio-option">
                        <input type="radio" name="pagamento" :value="true" v-model="inCashSelected" :disabled="loadingSentProposal" />
                        <span class="custom-radio"></span>
                        À vista
                      </label>

                      <label class="radio-option">
                        <input type="radio" name="pagamento" :value="false" v-model="inCashSelected" :disabled="loadingSentProposal" />
                        <span class="custom-radio"></span>
                        Parcelado
                      </label>
                    </div>
                  </div>
                  <div class="form-group mb-1" v-if="inCashSelected">
                    <label class="text-info">Informe o valor que deseja pagar</label>
                    <input class="form-control form-control-sm" placeholder="Digite aqui" id="form2"
                      v-model="inCashValueProposal" v-money="money" />
                  </div>
                  <div class="form-group mb-1" v-else>
                    <label class="text-info">Informe o valor da parcela desejada</label>
                    <input class="form-control form-control-sm" placeholder="Digite aqui" id="form2"
                      v-model="installmentValueProposal" v-money="money" />
                  </div>
                  <!-- <p style="font-size: 10px; color: #7c818a" class="mb-2">
                    Mínimo
                    {{
                      formatFloatToReal(
                        parseFloat(
                          installmentsOffers[0].groupingPlan[
                            installmentsOffers[0].groupingPlan.length - 1
                          ].installmentValueWithDiscount,
                          10
                        )
                      )
                    }}
                  </p> -->
                  <div v-if="isBelowThan" class="error-message">
                    <p style="font-size: 10px">
                      O valor de entrada é menor que o mínimo permitido de
                      <!-- {{
                      formatFloatToReal(
                        parseFloat(
                          installmentsOffers[0].groupingPlan[
                            installmentsOffers[0].groupingPlan.length - 1
                          ].installmentValueWithDiscount,
                          10
                        )
                      )
                    }}. -->
                    </p>
                  </div>
                  <div v-if="isAboveThan" class="error-message">
                    <p style="font-size: 10px">
                      O valor de entrada é maior que o máximo permitido de
                      <!-- {{
                      formatFloatToReal(
                        parseFloat(
                          installmentsOffers[0].groupingPlan[0]
                            .installmentValueWithDiscount,
                          10
                        )
                      )
                    }}. -->
                    </p>
                  </div>
                  <div class="form-group mb-2">
                    <label class="text-info">Informe a data que deseja pagar</label>
                    <select id="DiaSelect" class="form-control" v-model="dueDateSetYourProposal">
                      <option v-for="(date, dateIndex) in dueDatesSetYourProposal" :key="`date-${dateIndex}-${date}`">
                        {{ date }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group mb-4">
                    <label class="text-info">Informe seus melhores contatos</label>
                    <input type="email" class="form-control mb-3" placeholder="Informe um e-mail" id="formEmail"
                      v-model="newEmail" required />
                    <input type="tel" class="form-control" placeholder="Informe um telefone" id="form9"
                      v-mask="['(##) # ####-####']" v-model="newPhoneNumber" required />
                  </div>
                  <!-- <i class="fa fa-info-circle"></i> -->
                  <img src="/img/info-circle.svg" alt="" />
                  <label class="text-info ml-3" style="font-size: 10pt">Retornaremos em até 48h</label>
                </div>
              </form>
              <!-- :disabled="
                isAboveThan ||
                isBelowThan ||
                loading ||
                !convertCurrencyToFloat(entryValue) > 0
              " -->
              <button class="btn btn-primary btn-block" @click="sentYourProposalTribanco()"
                :disabled="!validateInputsProposal()" v-if="!loadingSentProposal">
                ENVIAR PROPOSTA
              </button>
              <button class="btn btn-link btn-block" :disabled="loading" @click="closeModalEntradaTribanco()" v-if="!loadingSentProposal">
                CANCELAR
              </button>
              <ProgressLoading v-bind:loading="loadingSentProposal" />
            </div>
          </div>
        </div>
      </div>

      <!-- TRICARD -->
      <div class="modal fade" id="entrada-tricard">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Monte sua proposta</h5>
              <button type="button" @click="closeModalEntradaTricard()">
                <span style="font-size: 12pt">×</span>
              </button>
            </div>
            <div class="modal-body pt-0">
              <form class="mb-0">
                <div class="form-group my-0">
                  <div class="form-group mb-1">
                    <label>Como deseja pagar?</label>
                    <div class="radio-group">
                      <label class="radio-option">
                        <input type="radio" name="pagamento" :value="true" v-model="inCashSelected"
                          :disabled="loadingSentProposal" />
                        <span class="custom-radio"></span>
                        À vista
                      </label>

                      <label class="radio-option">
                        <input type="radio" name="pagamento" :value="false" v-model="inCashSelected"
                          :disabled="loadingSentProposal" />
                        <span class="custom-radio"></span>
                        Parcelado
                      </label>
                    </div>
                  </div>
                  <div class="form-group mb-1" v-if="inCashSelected">
                    <label class="text-info">Informe o valor que deseja pagar</label>
                    <input class="form-control form-control-sm" placeholder="Digite aqui" id="form2"
                      v-model="inCashValueProposal" v-money="money" />
                  </div>
                  <div class="form-group mb-1" v-else>
                    <label class="text-info">Informe o valor da parcela desejada</label>
                    <input class="form-control form-control-sm" placeholder="Digite aqui" id="form2"
                      v-model="installmentValueProposal" v-money="money" />
                  </div>
                  <!-- <p style="font-size: 10px; color: #7c818a" class="mb-2">
                    Mínimo
                    {{
                      formatFloatToReal(
                        parseFloat(
                          installmentsOffers[0].groupingPlan[
                            installmentsOffers[0].groupingPlan.length - 1
                          ].installmentValueWithDiscount,
                          10
                        )
                      )
                    }}
                  </p> -->
                  <div v-if="isBelowThan" class="error-message">
                    <p style="font-size: 10px">
                      O valor de entrada é menor que o mínimo permitido de
                      <!-- {{
                      formatFloatToReal(
                        parseFloat(
                          installmentsOffers[0].groupingPlan[
                            installmentsOffers[0].groupingPlan.length - 1
                          ].installmentValueWithDiscount,
                          10
                        )
                      )
                    }}. -->
                    </p>
                  </div>
                  <div v-if="isAboveThan" class="error-message">
                    <p style="font-size: 10px">
                      O valor de entrada é maior que o máximo permitido de
                      <!-- {{
                      formatFloatToReal(
                        parseFloat(
                          installmentsOffers[0].groupingPlan[0]
                            .installmentValueWithDiscount,
                          10
                        )
                      )
                    }}. -->
                    </p>
                  </div>
                  <div class="form-group mb-2">
                    <label class="text-info">Informe a data que deseja pagar</label>
                    <select id="DiaSelect" class="form-control" v-model="dueDateSetYourProposal">
                      <option v-for="(date, dateIndex) in dueDatesSetYourProposal" :key="`date-${dateIndex}-${date}`">
                        {{ date }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group mb-4">
                    <label class="text-info">Informe seus melhores contatos</label>
                    <input type="email" class="form-control mb-3" placeholder="Informe um e-mail" id="formEmail"
                      v-model="newEmail" required />
                    <input type="tel" class="form-control" placeholder="Informe um telefone" id="form9"
                      v-mask="['(##) # ####-####']" v-model="newPhoneNumber" required />
                  </div>
                  <!-- <i class="fa fa-info-circle"></i> -->
                  <img src="/img/info-circle.svg" alt="" />
                  <label class="text-info ml-3" style="font-size: 10pt">Retornaremos em até 48h</label>
                </div>
              </form>
              <!-- :disabled="
                isAboveThan ||
                isBelowThan ||
                loading ||
                !convertCurrencyToFloat(entryValue) > 0
              " -->
              <button class="btn btn-primary btn-block" @click="sentYourProposalTricard()"
                :disabled="!validateInputsProposal()" v-if="!loadingSentProposal">
                ENVIAR PROPOSTA
              </button>
              <button class="btn btn-link btn-block" :disabled="loading" @click="closeModalEntradaTricard()"
                v-if="!loadingSentProposal">
                CANCELAR
              </button>
              <ProgressLoading v-bind:loading="loadingSentProposal" />
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="sentProposal">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" style="font-weight: 600">
                Sua proposta foi enviada!
              </h5>
              <button type="button" @click="closeModalSentProposal()">
                <span style="font-size: 12pt">×</span>
              </button>
            </div>
            <div class="modal-body pt-0">
              <form class="mb-0">
                <div class="form-group my-0">
                  <div class="form-group">
                    <label class="text-info">Dentro de até 48h entraremos em contato através do(s)
                      canal(ais) informado(s)</label>
                  </div>
                </div>
              </form>
              <button class="btn btn-primary btn-block" @click="closeModalSentProposal()">
                ENTENDI
              </button>
            </div>
          </div>
        </div>
      </div>
      </div>

      <div class="container" v-if="loading">
        <ProgressLoading v-bind:loading="loading" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  formatFloatToReal,
  formatData,
  getEaster,
  getBrazilianHolidays,
  isBusinessDay,
  parseBR,
  isValidPhoneNumber,
} from "@/utils/helpers";
import ProgressLoading from "../../modules/auth/components/ProgressLoading.vue";
import { VMoney } from "v-money";
import { mask } from "vue-the-mask";
import moment from "moment";
export default {
  name: "HistoricoPagamentos",
  components: {
    ProgressLoading,
  },
  directives: {
    money: VMoney,
    mask,
  },
  data() {
    return {
      loading: true,
      negociacao: null,
      selectDeal: null,
      selectedAll: [],
      digitalLine: null,
      checkSelectAll: false,
      checkContract: false,
      showFilter: true,
      validationError: false,
      valueByContract: {},
      showPendingCont: false,
      showDueCont: false,
      links: [],
      selected: {},
      dataAtual: new Date(Date.now()),
      offers: [],
      contracts: [],
      contractsOriginal: [],
      contractsInvoices: [],
      checkedParcels: [],
      checkedParcelsByContract: {},
      selectVariable: true,
      valueTotal: 0,
      largura: null,
      someContractIsSecondInvoice: false,
      responseFromAgreement: {},
      contractsUpdated: [],
      loadingOptionsInstallments: false,
      installmentOptions: [],
      selectedOption: {},
      contractChooseParcOptions: null,
      contractDetailsChooseParcOptions: null,
      userAdm: {},
      ipUser: null,
      currentPage: "dashboard",
      isAboveThan: null,
      isBelowThan: null,
      entryValue: null,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
      openContractDetailsCombo: false,
      openContractDetails: false,
      openContractDetailsIndividual: false,
      dueDate: null,
      dueDates: [],
      unicaDueDate: null,
      unicaDueDates: [],
      dueDateSetYourProposal: null,
      dueDatesSetYourProposal: [],
      optionsInstallments: [0, 2, 5, 8],
      openCombo: {},
      openIndividual: {},
      agreements: [],
      optionsByContract: {},
      didAutoSelect: false,
      baselineByContract: {},
      squelchSelectionChange: false,
      inCashSelected: true,
      inCashValueProposal: null,
      installmentValueProposal: null,
      newEmail: null,
      newPhoneNumber: null,
      loadingSentProposal: false,
      isRedirectingToAcordos: false,
    };
  },
  watch: {
    contracts: {
      immediate: true,
      handler(val, oldVal) {
        if (!Array.isArray(val) || !val.length) return;

        if (!this.didAutoSelect) {
          this.squelchSelectionChange = true;

          const d = new Date();
          const todayISO = `${d.getFullYear()}-${String(
            d.getMonth() + 1
          ).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
          const toISO = (s) => {
            if (!s) return null;
            if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) {
              const [dd, mm, yyyy] = s.split("/");
              return `${yyyy}-${mm}-${dd}`;
            }
            if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
            const x = new Date(s);
            return isNaN(+x) ? null : x.toISOString().slice(0, 10);
          };

          for (const c of val) {
            const lastIdx = this.lastSelectableIndex(c);
            let k = -1;
            for (let i = 0; i <= lastIdx; i++) {
              const iso = toISO(c.parcelas?.[i]?.vencimento);
              if (iso && iso <= todayISO) k = i;
            }
            const total = c.parcelas?.length || 0;
            for (let i = 0; i < total; i++) {
              const can = i <= lastIdx && c.parcelas?.[i]?.selectable !== false;
              this.setParcelSelected(c, i, can && i <= k);
            }
            if (String(c.credor || "").toUpperCase() !== "UNICA") {
              this.normalizeSelection(c);
            }
          }

          this.syncSelectionFromContracts();
          this.setBaselineFromCurrentSelection();
          this.didAutoSelect = true;

          this.squelchSelectionChange = false;
          return;
        }

        if (val !== oldVal) {
          this.syncSelectionFromContracts();
        }
      },
    },
  },

  methods: {
    formatFloatToReal,
    formatData,
    getEaster,
    getBrazilianHolidays,
    isBusinessDay,
    parseBR,
    isValidPhoneNumber,

    ...mapActions("minhasDividas", [
      "ActionGetDebtsTribanco",
      "ActionGetOffersTribanco",
      "ActionGetInvoicesTribanco",
      "ActionGetInstallmentsTribanco",
      "ActionGetOptionsInstallments",
      "ActionInsertProposalTricard",
      "ActionSendProposalTribancoEmail",
    ]),

    async getBoletos() {
      this.loading = true;
      this.$router.push({
        name: "meusBoletos",
      });
    },

    isMobile() {
      if (parseInt(this.largura) > 500) return false;
      return true;
    },

    showDueContracts() {
      if (
        (this.showDueCont && this.showPendingCont) ||
        (!this.showDueCont && !this.showPendingCont)
      ) {
        this.contracts = JSON.parse(localStorage.getItem("contracts"));
        this.$forceUpdate();
        return;
      }
      if (this.showPendingCont && !this.showDueCont) {
        this.showPendingContracts();
        return;
      }
      let filtered = this.contracts.filter((contract) => {
        return this.compareDates(
          formatData(contract.parcelas[0].vencimento, "YYYY-MM-DD", "L")
        );
      });
      this.contracts = filtered;
      this.$forceUpdate();
    },

    showPendingContracts() {
      if (
        (this.showPendingCont && this.showDueCont) ||
        (!this.showDueCont && !this.showPendingCont)
      ) {
        this.contracts = JSON.parse(localStorage.getItem("contracts"));
        this.$forceUpdate();
        return;
      }
      if (!this.showPendingCont && this.showDueCont) {
        this.showDueContracts();
        return;
      }
      let filtered = this.contracts.filter((contract) => {
        return !this.compareDates(
          formatData(contract.parcelas[0].vencimento, "YYYY-MM-DD", "L")
        );
      });
      this.contracts = filtered;
      this.$forceUpdate();
    },

    async selectAllByContract(contract) {
      contract.parcelas.map((installment) => {
        if (
          !this.selected[contract.contrato] &&
          this.checkedParcels.includes(installment)
        )
          return;
        else if (
          this.selected[contract.contrato] &&
          !this.checkedParcels.includes(installment)
        )
          return;
        else if (
          !this.selected[contract.contrato] &&
          !this.checkedParcels.includes(installment)
        ) {
          this.checkedParcels.push(installment);
        } else
          this.checkedParcels.splice(
            this.checkedParcels.indexOf(installment),
            1
          );
        this.calculateSingleInstallment(contract, installment);
      });
      this.selected[contract.contrato] = !this.selected[contract.contrato];
    },

    compareDates(date) {
      let parts = date.split("/");
      let today = new Date();
      date = new Date(parts[2], parts[1] - 1, parts[0]);
      return today > date ? true : false;
    },
    calculateSingleInstallment(contract, parcel) {
      this.valueTotal = 0;

      if (this.checkedParcels.length === 0) {
        this.valueByContract[contract.contrato] = 0;
        this.checkedParcelsByContract[contract.contrato] = [];
        return;
      }
      if (
        this.checkedParcels.filter((value) => {
          return value === parcel;
        }).length === 0
      ) {
        this.checkedParcelsByContract[contract.contrato][0].parcelas =
          this.checkedParcels.filter((value) => {
            return contract.parcelas.includes(value);
          });
        this.valueByContract[contract.contrato] -= parseBR(parcel.valor);
      } else {
        this.checkedParcelsByContract[contract.contrato].push({ ...contract });
        this.checkedParcelsByContract[contract.contrato][0].parcelas =
          this.checkedParcels.filter((value) => {
            return contract.parcelas.includes(value);
          });
        this.valueByContract[contract.contrato] += parseBR(parcel.valor);
      }

      this.checkedParcels.map((value) => {
        this.valueTotal += parseBR(value.valor);
      });
    },

    selectAll() {
      this.clear();

      this.contracts.map((contract) => {
        this.selectedAll.push(contract.contrato);
        this.selected[contract.contrato] = true;
        contract.parcelas.map((installment) => {
          this.checkedParcelsByContract[contract.contrato].push({
            ...contract,
          });
          this.checkedParcels.push(installment);
          this.valueTotal += parseBR(installment.valor);
          this.valueByContract[contract.contrato] += parseBR(
            installment.valor
          );
        });
      });
    },

    clear() {
      this.selectedAll = [];
      this.checkedParcels = [];
      this.valueTotal = 0;
      this.contracts.map((contract) => {
        this.valueByContract[contract.contrato] = 0;
        this.checkedParcelsByContract[contract.contrato] = [];
      });
    },

    voltar() {
      this.$router.push({
        name: "dashboard",
      });
    },

    checkInstallmentRules() {
      this.syncSelectionFromContracts();

      const barrierIdx = (c) => {
        const i = (c.parcelas || []).findIndex((p) => p?.selectable === false);
        return (i === -1 ? c.parcelas.length : i) - 1;
      };

      for (const contract of this.contracts || []) {
        const lastAllowed = barrierIdx(contract);

        const idxs = (contract.parcelas || [])
          .map((p, i) => (p && p.selected ? i : -1))
          .filter((i) => i >= 0)
          .sort((a, b) => a - b);

        if (idxs.length === 0) continue;

        const contiguo = idxs.every((v, i) => v === i);
        if (!contiguo) return false;

        if (idxs[idxs.length - 1] > lastAllowed) return false;
      }
      return true;
    },

    syncSelectionFromContracts() {
      this.checkedParcels = [];
      this.checkedParcelsByContract = {};
      this.valueByContract = {};

      (this.contracts || []).forEach((contract) => {
        const picked = [];
        (contract.parcelas || []).forEach((p, idx) => {
          if (p && p.selected) {
            picked.push({
              contrato: contract.contrato,
              parcela: idx + 1,
              valor: p.valor,
              vencimento: p.vencimento,
              secondInvoice: p.secondInvoice,
              parcelas: [{ parcela: idx + 1, valor: p.valor }],
            });
          }
        });

        if (picked.length) {
          this.$set(this.checkedParcelsByContract, contract.contrato, picked);
          this.valueByContract[contract.contrato] = picked.reduce(
            (a, x) => a + parseBR(x.valor),
            0
          );
          this.checkedParcels.push(...picked);
        } else {
          if (this.$delete)
            this.$delete(this.checkedParcelsByContract, contract.contrato);
          else delete this.checkedParcelsByContract[contract.contrato];
          delete this.valueByContract[contract.contrato];
        }
      });
    },

    resumoAcordoTricard(contract, installment) {
      const selectedInstallment = !installment
        ? contract.offers[0]
        : installment;

      this.$router.push({
        name: "resumoAcordoTricard",
        params: {
          contract: contract,
          installment: selectedInstallment,
        },
      });
    },

    async validateAndSnapshot({
      requireAtLeastOne = true,
      autoSync = true,
    } = {}) {
      if (autoSync) this.syncSelectionFromContracts();
      const ok = await Promise.resolve(this.checkInstallmentRules());
      if (!ok) throw new Error("Selecione parcela(s) em sequência!");

      const snapshot = this.buildSelectionSnapshot(this.contracts);
      if (requireAtLeastOne && !(snapshot?.installments?.length > 0)) {
        throw new Error("Selecione pelo menos 1 parcela para negociar!");
      }
      return snapshot;
    },

    getSelectionMap(contracts = this.contracts) {
      const map = {};
      (contracts || []).forEach((c) => {
        const idxs = [];
        (c.parcelas || []).forEach((p, i) => {
          if (p && p.selected) idxs.push(i);
        });
        if (idxs.length) map[c.contrato] = idxs;
      });
      return map;
    },

    reapplySelection(selectionMap) {
      (this.contracts || []).forEach((c) => {
        const idxs = selectionMap[c.contrato];
        if (!idxs || !idxs.length) return;
        (c.parcelas || []).forEach((_, i) =>
          this.setParcelSelected(c, i, false)
        );
        const livre = String(c.credor || "").toUpperCase() === "UNICA";
        idxs.forEach((i) => {
          const parc = c.parcelas?.[i];
          if (!parc) return;
          if (!livre && parc.selectable === false) return;
          this.setParcelSelected(c, i, true);
        });
        if (String(c.credor || "").toUpperCase() !== "UNICA") {
          this.normalizeSelection(c);
        }
      });
      this.syncSelectionFromContracts();
    },

    mergeContractsById(newContractsMap, contractIdsToReplace) {
      (this.contracts || []).forEach((c, idx) => {
        if (
          contractIdsToReplace.has(c.contrato) &&
          newContractsMap[c.contrato]
        ) {
          this.$set(this.contracts, idx, newContractsMap[c.contrato]);
        }
      });
    },

    async updateOffers({ issuer, contract = null }) {
      issuer;
      this.loadingOptionsInstallments = true;
      try {
        if (issuer === "TRIBANCO") {
          const target =
            contract ||
            (this.contracts || []).find((c) =>
              (c.parcelas || []).some((p) => p && p.selected)
            );

          if (!target?.contrato) {
            this.showError("Selecione ao menos uma parcela para atualizar.");
            return false;
          }

          this.contractChooseParcOptions = target.contrato;
          this.syncSelectionFromContracts();

          const idxs = (target.parcelas || [])
            .map((p, i) => (p && p.selected ? i : -1))
            .filter((i) => i >= 0);

          if (!idxs.length) {
            this.showError("Selecione ao menos uma parcela para atualizar.");
            return false;
          }

          const installments = idxs
            .map((i) => ({
              contract: target.contrato,
              product: target.produto,
              dueInstallmentDate: this.toISO(target?.parcelas?.[i]?.vencimento),
            }))
            .filter((i) => !!i.dueInstallmentDate);

          if (!installments.length) {
            this.showError("Parcela selecionada sem data de vencimento válida.");
            return false;
          }

          const prevSelection = this.getSelectionMap();
          const dueDateISO = this.toISO(this.dueDate || this.selectedDueDate);
          const fullySelected = this.isContractFullySelected(target);

          const resp = await this.ActionGetOffersTribanco({
            UserID: this.userAdm ? this.userAdm.UserID : null,
            UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
            document: String(target.regis),
            regis: String(target.regis),
            credor: target.credor,
            company: target.company,
            contract: target.contrato,
            product: target.produto,
            dueDate: dueDateISO || this.dueDate || this.selectedDueDate,
            inputValue: "0",
            options: fullySelected ? this.optionsInstallments : [0],
            installments,
            tag: localStorage.getItem("tag"),
            OS: navigator.platform,
            IP: this.ipUser || "",
          });

          // ActionGetOffersTribanco já devolve response.data.results
          const data =
            resp && (resp.offers !== undefined || resp.atSightOffer !== undefined)
              ? resp
              : null;

          const idx = (this.contracts || []).findIndex(
            (c) => c.contrato === target.contrato
          );

          if (idx >= 0 && data) {
            const hasFreshOffers =
              (Array.isArray(data.offers) && data.offers.length > 0) ||
              (data.atSightOffer !== undefined &&
                data.atSightOffer !== null &&
                data.atSightOffer !== "");

            if (hasFreshOffers) {
              if (data.offers !== undefined)
                this.$set(this.contracts[idx], "offers", data.offers);
              if (data.atSightOffer !== undefined && data.atSightOffer !== null)
                this.$set(this.contracts[idx], "atSightOffer", data.atSightOffer);
              if (data.discountValue !== undefined)
                this.$set(
                  this.contracts[idx],
                  "discountValue",
                  data.discountValue
                );
              if (data.discountPercentage !== undefined)
                this.$set(
                  this.contracts[idx],
                  "discountPercentage",
                  data.discountPercentage
                );
            }
            if (data.minimumDate !== undefined)
              this.$set(this.contracts[idx], "minimumDate", data.minimumDate);
            if (data.maximumDate !== undefined)
              this.$set(this.contracts[idx], "maximumDate", data.maximumDate);
          }

          this.reapplySelection(prevSelection);
          this.setBaselineFromCurrentSelection([
            this.contracts[idx] || target,
          ]);
        } else if (issuer === "TRICARD") {
          // --- TRICARD: recalcula offers e atualiza os campos do card ---
          const resp = await this.ActionGetDebtsTribanco({
            UserID: this.userAdm ? this.userAdm.UserID : null,
            UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
            dueDate: this.dueDate || this.selectedDueDate,
            options: this.optionsInstallments,
            tag: localStorage.getItem("tag"),
            OS: navigator.platform,
            IP: this.ipUser || "",
            selection: null,
          });

          const list = Array.isArray(resp) ? resp : [];
          // helper para converter "1.234,56" -> 1234.56
          const parseBR = (v) =>
            typeof v === "number"
              ? v
              : Number(String(v).replace(/\./g, "").replace(",", ".")) || 0;

          // aplica reativamente os campos usados no card
          list.forEach((c, i) => {
            const offer0 = Array.isArray(c.offers) ? c.offers[0] : null;
            const ret = offer0?.RETORNO || {};
            const parc = offer0?.PARCELAS;

            // à vista (preferir RETORNO.VALORTOTAL; fallback PARCELAS.PAGO)
            const atSight =
              ret.VALORTOTAL ??
              (Array.isArray(parc) ? parc[0]?.PAGO : parc?.PAGO) ??
              c.atSightOffer;
            if (atSight !== undefined) list[i].atSightOffer = atSight;

            // desconto e % (se houver)
            if (ret.DESCONTO !== undefined)
              list[i].discountValue = ret.DESCONTO;
            if (ret.PRINCIPAL !== undefined && ret.DESCONTO !== undefined) {
              const pct =
                parseBR(ret.PRINCIPAL) > 0
                  ? Math.round(
                    (parseBR(ret.DESCONTO) / parseBR(ret.PRINCIPAL)) * 100
                  )
                  : null;
              if (pct !== null) list[i].discountPercentage = pct;
            }
          });

          const prevSelection = this.getSelectionMap();
          this.contracts = list.length ? list : [];
          this.reapplySelection(prevSelection);
          this.rulesClient?.();
        } else {
          throw new Error("Issuer inválido. Use 'TRIBANCO' ou 'TRICARD'.");
        }
        return true;
      } catch (e) {
        this.showError(e.message || "Falha ao atualizar ofertas.");
        return false;
      } finally {
        this.loadingOptionsInstallments = false;
      }
    },

    onDueDateChangeTribanco(contract) {
      if (this.selectedCount(contract) === 0) return;
      this.updateOffers({ issuer: "TRIBANCO", contract });
    },

    async updateOffer() {
      this.loading = true;

      var resp = await this.ActionGetDebtsTribanco({
        UserID: this.userAdm ? this.userAdm.UserID : null,
        UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
        dueDate: this.dueDate,
        options: this.optionsInstallments,
        tag: localStorage.getItem("tag"),
        OS: navigator.platform,
        IP: this.ipUser,
        selection: null,
      });

      this.contracts = resp.length > 0 ? resp : [];

      this.rulesClient();

      this.loading = false;
    },

    async updateOfferTribanco() {
      try {
        const snapshot = await this.validateAndSnapshot({
          requireAtLeastOne: true,
          autoSync: true,
        });
        const payload = this.buildAgreementPayload(snapshot, {
          dueDate:
            this.selectedDueDate || new Date().toLocaleDateString("en-CA"),
          installmentNumber: "0",
          inputValue: "0",
          source: 1,
        });

        localStorage.setItem("agreementPayload", JSON.stringify(payload));
      } catch (e) {
        this.showError(e.message || "Falha ao atualizar condições.");
      }
    },

    contractSelectionSig(contract) {
      if (!contract) return "";
      const selIdx = (contract.parcelas || [])
        .map((p, i) => (p && p.selected ? i + 1 : null))
        .filter(Boolean);
      return `${contract.contrato}:${selIdx.join(",")}`;
    },

    selectionSignature(contracts, extras = {}) {
      const parts = [];

      for (const c of contracts || []) {
        const sig = this.contractSelectionSig(c);
        if (sig && !sig.endsWith(":")) parts.push(sig);
      }

      parts.sort();
      extras;

      return parts.join("|");
    },

    setBaselineFromCurrentSelection(contracts = null) {
      const list = contracts || this.contracts || [];
      list.forEach((c) => {
        if (!c?.contrato) return;
        this.$set(this.baselineByContract, c.contrato, this.contractSelectionSig(c));
      });
    },

    needsUpdate(contract) {
      if (!contract?.contrato) return false;
      const base = this.baselineByContract[contract.contrato];
      if (base === undefined) return false;
      return this.contractSelectionSig(contract) !== base;
    },

    setParcelSelected(contract, i, val) {
      const parc = contract.parcelas[i];
      if (!("selected" in parc)) this.$set(parc, "selected", !!val);
      else parc.selected = !!val;
    },

    async negociar() {
      try {
        const snapshot = await this.validateAndSnapshot({
          requireAtLeastOne: true,
          autoSync: true,
        });
        const payload = this.buildAgreementPayload(snapshot, {
          dueDate:
            this.selectedDueDate || new Date().toLocaleDateString("en-CA"),
          installmentNumber: "0", // à vista
          inputValue: "0",
          source: 1,
        });

        localStorage.setItem("agreementPayload", JSON.stringify(payload));
        this.$router.push({ name: "resumoAcordoTribanco" });
      } catch (e) {
        this.showError(e.message || "Erro ao montar o acordo.");
      }
    },

    abrirPropostasTribanco(contract) {
      if (!contract?.contrato) return;
      localStorage.setItem(
        "propostaTribancoContract",
        JSON.stringify(contract)
      );
      localStorage.setItem(
        "propostaTribancoDueDates",
        JSON.stringify(this.dueDates || [])
      );
      localStorage.setItem(
        "propostaTribancoDueDate",
        this.dueDate || ""
      );
      this.$router.push({
        name: "propostasTribanco",
        params: { contractId: String(contract.contrato) },
      });
    },

    hasRealDiscount(contract) {
      if (!contract) return false;
      const from = parseBR(contract.offers?.[0]?.RETORNO?.VALORPARCELAR);
      const to = parseBR(
        contract.atSightOffer ?? contract.offers?.[0]?.RETORNO?.VALORTOTAL
      );
      if (from > 0 && to > 0 && from > to) return true;
      if (parseBR(contract.discountPercentage) > 0) return true;
      if (
        parseBR(
          contract.discountValue ?? contract.offers?.[0]?.RETORNO?.DESCONTO
        ) > 0
      ) {
        return true;
      }
      return false;
    },

    isUnicaContract(contract) {
      return String(contract?.credor || "").toUpperCase() === "UNICA";
    },

    isUnicaContractSelected(contract) {
      const parcelas = contract?.parcelas || [];
      return parcelas.length > 0 && parcelas.every((p) => p && p.selected);
    },

    toggleContratoUnica(contract) {
      const next = !this.isUnicaContractSelected(contract);
      (contract.parcelas || []).forEach((_, i) =>
        this.setParcelSelected(contract, i, next)
      );
      this.syncSelectionFromContracts();
    },

    unicaContractValue(contract) {
      const total = (contract?.parcelas || []).reduce(
        (acc, p) => acc + this.parseBR(p?.valor),
        0
      );
      return total.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    unicaDueLabel(contract) {
      const dates = (contract?.parcelas || [])
        .map((p) => p?.vencimento)
        .filter(Boolean);
      if (!dates.length) return "";
      const first = this.formatData(dates[0], "YYYY-MM-DD", "DD/MM/YYYY");
      if (dates.length === 1) return first;
      return `${first} a ${this.formatData(
        dates[dates.length - 1],
        "YYYY-MM-DD",
        "DD/MM/YYYY"
      )}`;
    },

    negociarUnica() {
      const selected = (this.contractsUnica || []).filter((c) =>
        this.isUnicaContractSelected(c)
      );
      if (!selected.length) {
        this.showError("Selecione ao menos um contrato.");
        return;
      }

      try {
        const snapshot = this.buildSelectionSnapshot(selected);
        const payload = this.buildAgreementPayloadTribanco(snapshot, {
          dueDate: this.unicaDueDate,
          installmentNumber: "0",
          inputValue: "0",
          source: 1,
          contractIds: selected.map((c) => String(c.contrato)),
        });

        localStorage.setItem("agreementPayload", JSON.stringify(payload));
        this.$router.push({ name: "resumoAcordoTribanco" });
      } catch (e) {
        this.showError(e.message || "Erro ao montar o acordo.");
      }
    },

    async negociarTribanco(installment, targetContract = null) {
      var installmentNumber =
        installment === 0 ? 0 : installment.INSTALLMENTnUMBER;

      var discountPerc = null;
      const prevSelection = this.getSelectionMap();

      if (targetContract) {
        // Negociação individual: usa só o contrato do card clicado,
        // sem apagar a seleção dos outros se der erro no caminho.
        (this.contracts || []).forEach((c) => {
          if (c.contrato === targetContract.contrato) return;
          (c.parcelas || []).forEach((_, i) => this.setParcelSelected(c, i, false));
        });
        this.syncSelectionFromContracts();
      }

      if (installmentNumber === 0) {
        const selectedContract =
          targetContract ||
          this.contracts.find(c => c.parcelas && c.parcelas.some(p => p.selected));
        if (selectedContract) {
          discountPerc = selectedContract.discountPercentage;
        }
      } else {
        discountPerc = this.calculateDiscountPercentage(installment);
      }

      try {
        if (targetContract && this.selectedCount(targetContract) === 0) {
          throw new Error("Selecione ao menos uma parcela deste contrato.");
        }

        const snapshot = await this.validateAndSnapshot({
          requireAtLeastOne: true,
          autoSync: true,
        });

        const payload = this.buildAgreementPayloadTribanco(snapshot, {
          dueDate:
            this.dueDate ||
            this.selectedDueDate ||
            new Date().toLocaleDateString("en-CA"),
          installmentNumber: String(installmentNumber),
          discountPercentage:
            discountPerc === null || discountPerc === undefined
              ? null
              : String(discountPerc),
          inputValue:
            installmentNumber === 0
              ? "0"
              : String(installment.PARCELAS[0].PAGO),
          source: 1,
          targetContractId: targetContract?.contrato || null,
        });

        localStorage.setItem("agreementPayload", JSON.stringify(payload));
        this.$router.push({ name: "resumoAcordoTribanco" });
      } catch (e) {
        if (targetContract) this.reapplySelection(prevSelection);
        this.showError(e.message || "Erro ao montar o acordo.");
      }
    },

    toSecondInvoice(contracts, onlyContractsSecondInvoice) {
      localStorage.setItem(
        "contractsUpdated",
        JSON.stringify(this.contractsUpdated)
      );
      this.$router.push({
        name: "meusAcordos",
        params: {
          responseFromAgreement: contracts,
          onlyContractsSecondInvoice,
          segundaViaBoleto: false,
        },
      });
    },

    showError(message) {
      this.flashMessage.show({
        timeout: 1000,
        status: "error",
        blockClass: "custom-block-class",
        title: "Ocorreu um erro",
        message,
      });
    },

    generatePDF(value) {
      const linkSource = `data:application/pdf;base64,${value}`;
      const downloadLink = document.createElement("a");
      downloadLink.setAttribute("target", "_blank");
      const fileName = "boleto-parcela.pdf";
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },

    async consultarOpcoesParcelamento(contract) {
      if (this.checkedParcels.length < 1) {
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          blockClass: "custom-block-class",
          title: "Ocorreu um erro",
          message: `Selecione pelo menos 1 parcela para negociar!`,
        });
        return;
      }

      this.installmentOptions = [];
      this.selectedOption = {};
      this.contractChooseParcOptions = contract.contrato;
      this.contractDetailsChooseParcOptions = contract;
      this.loadingOptionsInstallments = true;

      try {
        var resp = await this.ActionGetOptionsInstallments({
          document: contract.regis,
          credor: contract.credor,
          company: contract.company,
          product: contract.produto,
          contract: contract.contrato,
          dueDate: contract.parcelas[0].vencimento,
          tag: localStorage.getItem("tag"),
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          OS: navigator.platform,
          IP: this.ipUser,
        });

        this.installmentOptions = resp;
        this.selectedOption = resp[0];
      } catch (error) {
        this.loadingOptionsInstallments = false;
      }
      this.loadingOptionsInstallments = false;
    },

    segundaViaBoleto(contract, option) {
      if (option === null) {
        option = this.selectedOption;
      }
      this.$router.push({
        name: "meusBoletos",
        params: {
          responseFromAgreement: contract,
          option: option,
          segundaViaBoleto: true,
        },
      });
    },

    getValue(selectedValue) {
      const value = JSON.parse(selectedValue);
      return (this.selectedOption = value);
    },

    home() {
      localStorage.setItem("currentPage", "dashboard");
      // Quando usuário navega manualmente para Propostas, não deve redirecionar automaticamente
      // então marcamos que ele escolheu ficar aqui
      sessionStorage.setItem("userChosePropostas", "true");
      if (this.$route.name !== "dashboard") {
        this.$router.push({ name: "dashboard" });
      }
    },

    meusAcordos() {
      localStorage.setItem("currentPage", "meusAcordos");
      this.$router.push({ name: "meusAcordos" });
    },

    filterInstallmentsOptions(numberOfInstallments) {
      if (numberOfInstallments > 2 && numberOfInstallments <= 5) {
        return [2, 3, 5];
      } else if (numberOfInstallments > 5 && numberOfInstallments <= 6) {
        return [2, 4, 6];
      } else if (numberOfInstallments > 6 && numberOfInstallments <= 8) {
        return [2, 4, 8];
      } else if (numberOfInstallments > 8 && numberOfInstallments <= 10) {
        return [3, 6, 9];
      } else if (numberOfInstallments > 10 && numberOfInstallments <= 12) {
        return [3, 9, 12];
      } else if (numberOfInstallments > 12 && numberOfInstallments <= 15) {
        return [3, 9, 15];
      } else if (numberOfInstallments > 15) {
        return [
          Math.ceil(numberOfInstallments / 3),
          Math.ceil((numberOfInstallments / 3) * 2),
          numberOfInstallments,
        ];
      }
    },

    validateEntryValue() {
      let entryValue = String(
        parseFloat(
          this.entryValue
            .replace("R$ ", "")
            .replace(/\./g, "")
            .replace(",", ".")
        )
      );
      this.isBelowThan =
        parseFloat(entryValue) > 0 &&
        parseFloat(entryValue) <
        parseFloat(
          this.installmentsOffers[0].groupingPlan[
            this.installmentsOffers[0].groupingPlan.length - 1
          ].installmentValueWithDiscount
        );
      this.isAboveThan =
        parseFloat(entryValue) > 0 &&
        parseFloat(entryValue) >
        parseFloat(
          this.installmentsOffers[0].groupingPlan[0]
            .installmentValueWithDiscount
        );
    },

    openModalSentProposal() {
      // this.validateProposalOptions();
      const modal = document.getElementById("sentProposal");
      modal.classList.add("show");
      modal.style.display = "block";
      document.body.classList.add("modal-open");
    },

    closeModalSentProposal() {
      // this.entryValue = null;
      document.getElementById("sentProposal").style.display = "none";
    },

    openModalEntradaTribanco() {
      // this.validateProposalOptions();
      const modal = document.getElementById("entrada-tribanco");
      modal.classList.add("show");
      modal.style.display = "block";
      document.body.classList.add("modal-open");
    },

    closeModalEntradaTribanco() {
      this.inCashValueProposal = null;
      this.installmentValueProposal = null;
      this.newEmail = null;
      this.newPhoneNumber = null;
      document.getElementById("entrada-tribanco").style.display = "none";
    },

    openModalEntradaTricard() {
      // this.validateProposalOptions();
      const modal = document.getElementById("entrada-tricard");
      modal.classList.add("show");
      modal.style.display = "block";
      document.body.classList.add("modal-open");
    },

    closeModalEntradaTricard() {
      this.inCashValueProposal = null;
      this.installmentValueProposal = null;
      this.newEmail = null;
      this.newPhoneNumber = null;
      document.getElementById("entrada-tricard").style.display = "none";
    },

    // validateEmail(email) {
    //   if (typeof email !== "string") return false;
    //   const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i; // sem espaços, sem @ nas partes, TLD >= 2
    //   return re.test(email.trim());
    // },

    validateEmailAndPhoneNumber() {
      if (
        (!this.newEmail && !this.newPhoneNumber) ||
        (this.newEmail == "" && !this.newPhoneNumber == "")
      ) {
        this.flashMessage.show({
          timeout: 300,
          status: "error",
          position: "top right",
          blockClass: "custom-block-class",
          title: "Erro",
          message: "informe os meios de contato",
        });
        return false;
      }

      var email = this.validateEmail(this.newEmail);

      if (!email) {
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          title: "Ocorreu um erro",
          message: "Informe um email válido!",
        });
        this.loading = false;
        return false;
      }

      var phoneIsValid = isValidPhoneNumber(this.newPhoneNumber);

      if (!phoneIsValid) {
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          title: "Error",
          message: "Informe um telefone válido!",
        });
        this.loading = false;
        this.loadingSetAgreement = false;
        return false;
      }

      return true;
    },

    // validateEntryOrInstallmentValue() {
    //   var debt = this.contracts[0];

    //   if (this.inCashSelected) {
    //     var res =
    //       parseFloat(this.inCashValueProposal) > parseFloat(debt.atSightOffer);

    //     if (res) {
    //       this.flashMessage.show({
    //         timeout: 1000,
    //         status: "error",
    //         title: "Error",
    //         message: "O valor escolhido é maior que o valor à vista com desconto!",
    //       });
    //       this.loading = false;
    //       return false;
    //     }
    //   }
    // },

    async sentYourProposalTribanco() {
      this.loadingSentProposal = true;
      var resultValidate = this.validateEmailAndPhoneNumber();

      console.log("user: " + JSON.stringify(this.user));

      // var resultValidateValue = this.validateEntryOrInstallmentValue();

      var valueFinal = this.inCashSelected
        ? this.inCashValueProposal
        : this.installmentValueProposal;

      var paymentMode = this.inCashSelected ? "CASH" : "INSTALLMENT";

      if (!valueFinal || valueFinal == "") {
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          title: "Error",
          message: this.inCashSelected
            ? "Informe um valor à vista válido!"
            : "Informe um valor de parcela válido!",
        });
        this.loading = false;
        return;
      }

      resultValidate;
      if (resultValidate) {
        // DISPARO DA PROPOSTA
        try {
          var res = await this.ActionSendProposalTribancoEmail({
            UserID: this.userAdm ? this.userAdm.UserID : null,
            UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
            DebtorID: this.user.DebtorID,
            DocNumber: this.user.DocNumber,
            PhoneNumber: this.newPhoneNumber.replace("(", "")
              .replace(")", "")
              .replace(" ", "")
              .replace(" ", "")
              .replace("-", ""),
            Email: this.newEmail,
            PaymentMode: paymentMode,
            DueDate: this.dueDateSetYourProposal,
            Value: valueFinal,
            tag: localStorage.getItem("tag"),
            OS: navigator.platform,
            IP: this.ipUser,
          });

          console.log("res: " + JSON.stringify(res));

          if (res) {
            this.flashMessage.show({
              timeout: 300,
              status: "success",
              position: "top right",
              blockClass: "custom-block-class",
              title: "Sucesso",
              message: "Sua proposta foi enviada com sucesso, aguarde retorno em até 48 horas!",
            });
            this.loadingSentProposal = false;
          } else {
            this.flashMessage.show({
              timeout: 300,
              status: "error",
              position: "top right",
              blockClass: "custom-block-class",
              title: "Erro",
              message: "Ocorreu um erro ao enviar a proposta, tente novamente mais tarde!",
            });
            this.loadingSentProposal = false;
          }
        } catch (error) {
          this.loadingSentProposal = false;
        }
      }
    },

    async sentYourProposalTricard() {
      this.loadingSentProposal = true;
      var resultValidate = this.validateEmailAndPhoneNumber();

      console.log("user: " + JSON.stringify(this.user));

      // var resultValidateValue = this.validateEntryOrInstallmentValue();

      var valueFinal = this.inCashSelected
        ? this.inCashValueProposal
        : this.installmentValueProposal;

      var paymentMode = this.inCashSelected ? "CASH" : "INSTALLMENT";

      if (!valueFinal || valueFinal == "") {
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          title: "Error",
          message: this.inCashSelected
            ? "Informe um valor à vista válido!"
            : "Informe um valor de parcela válido!",
        });
        this.loading = false;
        return;
      }

      try {
        if (resultValidate) {
          var res = await this.ActionInsertProposalTricard({
            UserID: this.userAdm ? this.userAdm.UserID : null,
            UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
            DebtorID: this.user.DebtorID,
            DocNumber: this.user.DocNumber,
            PhoneNumber: this.newPhoneNumber
              .replace("(", "")
              .replace(")", "")
              .replace(" ", "")
              .replace(" ", "")
              .replace("-", ""),
            Email: this.newEmail,
            PaymentMode: paymentMode,
            DueDate: this.dueDateSetYourProposal,
            Value: valueFinal,
            tag: localStorage.getItem("tag"),
            OS: navigator.platform,
            IP: this.ipUser,
            selection: null,
          });

          console.log("res: " + JSON.stringify(res));

          if (res) {
            this.flashMessage.show({
              timeout: 300,
              status: "success",
              position: "top right",
              blockClass: "custom-block-class",
              title: "Sucesso",
              message:
                "Sua proposta foi enviada com sucesso, aguarde retorno em até 48 horas!",
            });

            this.loadingSentProposal = false;
            this.closeModalEntradaTricard();
          }
        }
      } catch (error) {
        this.loadingSentProposal = false;
      } finally {
        this.loadingSentProposal = false;
      }
    },

    convertCurrencyToFloat(currencyStr) {
      let numberStr = null;
      if (currencyStr !== null) {
        numberStr = currencyStr
          .replace(/R\$\s?/, "")
          .replace(".", "")
          .replace(",", ".");
        return parseFloat(numberStr);
      } else {
        return;
      }
    },

    isComboOpen(c) {
      return !!this.openCombo[c.contrato];
    },
    isIndividualOpen(c) {
      return !!this.openIndividual[c.contrato];
    },

    toggleCombo(c) {
      this.$set(this.openCombo, c.contrato, !this.isComboOpen(c));
    },
    toggleIndividual(c) {
      this.$set(this.openIndividual, c.contrato, !this.isIndividualOpen(c));
    },

    openCloseContractsDetails() {
      this.openContractDetails = !this.openContractDetails;
    },

    openCloseContractsDetailsIndividual() {
      this.openContractDetailsIndividual = !this.openContractDetailsIndividual;
    },

    earliestMaximumDate(debts) {
      const dated = (debts || []).filter(
        (d) =>
          String(d?.credor || "").toUpperCase() !== "UNICA" && d?.maximumDate
      );
      const source = dated.length
        ? dated
        : (debts || []).filter((d) => d?.maximumDate);
      let maximumDate = null;
      source.forEach((d) => {
        const parsed = moment(d.maximumDate, "DD/MM/YYYY", true);
        if (!parsed.isValid()) return;
        if (!maximumDate || parsed.isBefore(maximumDate)) maximumDate = parsed;
      });
      return maximumDate;
    },

    populateDates(debts) {
      const now = moment();
      const maximumDate = this.earliestMaximumDate(debts);
      const holidays = getBrazilianHolidays(now.year());

      let count = 0;

      while (count < 5) {
        if (maximumDate && now.isAfter(maximumDate)) {
          break;
        }

        if (isBusinessDay(now, holidays)) {
          this.dueDates.push(now.format("DD/MM/YYYY"));
          count++;
        }
        now.add(1, "day");
      }
      this.dueDate = this.dueDates[0];
    },

    populateUnicaDueDate() {
      const cursor = moment().startOf("day");
      const holidays = [
        ...getBrazilianHolidays(cursor.year()),
        ...getBrazilianHolidays(cursor.year() + 1),
      ];
      const dates = [];

      while (dates.length < 10) {
        if (isBusinessDay(cursor, holidays)) {
          dates.push(cursor.format("DD/MM/YYYY"));
        }
        cursor.add(1, "day");
      }

      this.unicaDueDates = dates;
      this.unicaDueDate = dates[0] || null;
    },

    rulesClient() {
      this.contractsOriginal = this.contracts || [];

      this.agreements = (this.contracts || []).filter((contract) => {
        return contract.produto === "PARC";
      });

      this.contracts = (this.contracts || []).filter((contract) => {
        this.selected[contract.contrato] = false;
        this.valueByContract[contract.contrato] = 0;
        this.checkedParcelsByContract[contract.contrato] = [];
        return contract.produto !== "PARC";
      });

      this.contracts.map((value) => {
        if (
          value.produto.substr(0, 3) === "CCO" &&
          value.company === "TRICARD"
        ) {
          let index = this.contracts.indexOf(value);
          this.contracts.splice(index, 1);
        }
      });

      var dataDeReferencia = new Date();
      const dataAtual = new Date();

      this.contractsUpdated = this.contracts;

      this.contractsUpdated.map((item) => {
        dataDeReferencia = new Date(item.parcelas[0].vencimento);

        const diferencaEmDias = Math.floor(
          (dataAtual - dataDeReferencia) / (1000 * 60 * 60 * 24)
        );
        if (
          (item.company === "TRIBANCO" && item.produto === "CAR00110") ||
          item.produto === "CAR00200"
        ) {
          if (diferencaEmDias > 67) {
            item.secondInvoice = false;
          } else {
            item.secondInvoice = true;
            this.someContractIsSecondInvoice = true;
          }
        } else if (item.company === "TRICARD") {
          if (diferencaEmDias > 67) {
            item.secondInvoice = false;
          } else {
            item.secondInvoice = true;
            this.someContractIsSecondInvoice = true;
          }
        } else {
          item.secondInvoice = false;
        }
      });

      localStorage.setItem("contractsUpdated", this.contractsUpdated);
      localStorage.setItem("agreements", JSON.stringify(this.agreements));

      this.showFilter = this.$route.params.showFilter;
    },

    async loadInvoicesAsAgreements() {
      try {
        // Buscar invoices do localStorage primeiro
        let invoicesResponse = null;
        const storedInvoices = localStorage.getItem("contractsInvoices");
        if (storedInvoices) {
          try {
            const parsed = JSON.parse(storedInvoices);
            // Se for array, pegar o primeiro item
            invoicesResponse = Array.isArray(parsed) ? parsed[0] : parsed;
          } catch (e) {
            console.warn("Erro ao parsear invoices do localStorage:", e);
          }
        }

        // Se não houver no localStorage, usar contractsInvoices já carregado pelo fluxo principal
        if (!invoicesResponse && this.contractsInvoices && this.contractsInvoices.length > 0) {
          invoicesResponse = this.contractsInvoices[0];
        }

        // Transformar invoices em formato de acordo
        // A API retorna { results: { ... } } ou diretamente { ... }
        let invoice = null;
        if (invoicesResponse) {
          if (invoicesResponse.results && invoicesResponse.results.Contrato) {
            // Formato: { results: { Contrato: "...", ... } }
            invoice = invoicesResponse.results;
          } else if (invoicesResponse.Contrato) {
            // Se já for o objeto invoice diretamente
            invoice = invoicesResponse;
          }
        }

        if (invoice && invoice.Contrato) {
          // Garantir que agreements seja um array
          if (!Array.isArray(this.agreements)) {
            this.agreements = [];
          }

          // Verificar se já existe um acordo com este contrato
          const existingAgreementIndex = this.agreements.findIndex(
            (a) => a.contrato === invoice.Contrato
          );

          // Converter data ISO para formato YYYY-MM-DD se necessário
          let vencimento = invoice.Vencimento;
          if (vencimento && vencimento.includes("T")) {
            vencimento = vencimento.split("T")[0];
          }

          // Criar objeto de acordo no formato esperado
          const invoiceAgreement = {
            contrato: invoice.Contrato,
            parcelas: [
              {
                valor: invoice.ValorDocumento,
                vencimento: vencimento,
              },
            ],
            // Informações adicionais do invoice para uso posterior
            invoiceData: {
              DigitableLine: invoice.DigitableLine,
              DownloadLink: invoice.DownloadLink,
              Telefone: invoice.Telefone,
              Email: invoice.Email,
              Nome: invoice.Nome,
            },
          };

          if (existingAgreementIndex >= 0) {
            // Se já existe, substituir
            this.$set(this.agreements, existingAgreementIndex, invoiceAgreement);
          } else {
            // Adicionar novo acordo
            this.agreements.push(invoiceAgreement);
          }

          // Atualizar localStorage com agreements atualizados
          localStorage.setItem("agreements", JSON.stringify(this.agreements));
        }
      } catch (e) {
        console.error("Erro ao carregar invoices como acordos:", e);
      }
    },

    canShowMore(contract) {
      if (
        !Array.isArray(this.optionsInstallments) ||
        this.optionsInstallments.length === 0
      ) {
        this.optionsInstallments = [0, 2, 5, 8];
      }
      const maxIndex = (contract?.maxInstallmentNumber ?? 24) - 1; // 24x => último índice 23
      const last = Math.max(...this.optionsInstallments);
      return last < maxIndex;
    },

    organizeNumberOptionsInstallments(contract) {
      if (
        !Array.isArray(this.optionsInstallments) ||
        this.optionsInstallments.length === 0
      ) {
        this.optionsInstallments = [0, 2, 5, 8];
      }

      const maxIndex = (contract?.maxInstallmentNumber ?? 24) - 1; // limite real de índice
      // pega o maior já adicionado a partir do 8 (9x é o primeiro adicional)
      const base = Math.max(
        8,
        ...this.optionsInstallments.filter((n) => n >= 8)
      );
      const start = base + 1; // primeira nova posição (9 na 1ª vez)

      const toAdd = [];
      for (let i = 0; i < 3 && start + i <= maxIndex; i++) {
        toAdd.push(start + i); // ex.: [9,10,11], depois [12,13,14]…
      }

      // adiciona sem duplicar e mantém ordenado
      this.optionsInstallments = [
        ...new Set([...this.optionsInstallments, ...toAdd]),
      ].sort((a, b) => a - b);
    },

    async showMoreOptions(contract, from) {
      // só adiciona se ainda puder
      this.contractChooseParcOptions = contract.contrato;
      if (!this.canShowMore(contract)) return;
      this.organizeNumberOptionsInstallments(contract);
      await this.updateOffers({ issuer: from, contract }); // mantém seu fluxo atual
    },

    lastSelectableIndex(contract) {
      const i = (contract.parcelas || []).findIndex((p) => p?.selectable === false);
      return (i === -1 ? (contract.parcelas || []).length : i) - 1;
    },

    parcelDueISO(parc) {
      const s = parc?.vencimento;
      if (!s) return null;
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) {
        const [dd, mm, yyyy] = s.split("/");
        return `${yyyy}-${mm}-${dd}`;
      }
      if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
      const x = new Date(s);
      return Number.isNaN(+x) ? null : x.toISOString().slice(0, 10);
    },

    todayISO() {
      const d = new Date();
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
        d.getDate()
      ).padStart(2, "0")}`;
    },

    isOverdueOrCurrent(parc) {
      const iso = this.parcelDueISO(parc);
      return !!(iso && iso <= this.todayISO());
    },

    // Só a parcela mais antiga (atrasada/atual) fica obrigatória.
    requiredPrefixIndex(contract) {
      const lastIdx = this.lastSelectableIndex(contract);
      for (let i = 0; i <= lastIdx; i++) {
        if (this.isOverdueOrCurrent(contract.parcelas?.[i])) return i;
      }
      return -1;
    },

    lastSelectedIndex(contract) {
      const lastIdx = this.lastSelectableIndex(contract);
      let k = -1;
      for (let i = 0; i <= lastIdx; i++) {
        if (contract.parcelas?.[i]?.selected) k = i;
        else break;
      }
      return k;
    },

    canToggleParcela(contract, idx) {
      const lastIdx = this.lastSelectableIndex(contract);
      const parc = contract.parcelas?.[idx];
      if (idx < 0 || idx > lastIdx || !parc || parc.selectable === false) {
        return false;
      }

      const lastSelected = this.lastSelectedIndex(contract);
      const required = this.requiredPrefixIndex(contract);

      if (parc.selected) {
        // Só desmarca a última da sequência, e nunca a mais antiga obrigatória.
        return idx === lastSelected && idx > required;
      }

      // Só marca a próxima da sequência (não pula).
      return idx === lastSelected + 1;
    },

    normalizeSelection(contract) {
      const lastIdx = this.lastSelectableIndex(contract);
      const required = this.requiredPrefixIndex(contract);
      let k = -1;
      for (let i = 0; i <= lastIdx; i++) {
        if (contract.parcelas[i].selected) k = i;
        else break;
      }
      if (k < required) k = required;
      for (let i = 0; i <= lastIdx; i++)
        this.setParcelSelected(contract, i, i <= k);
      for (let i = lastIdx + 1; i < (contract.parcelas || []).length; i++)
        this.setParcelSelected(contract, i, false);
    },

    toggleContrato(contract, checked) {
      const lastIdx = this.lastSelectableIndex(contract);
      const required = this.requiredPrefixIndex(contract);
      const maxIdx = checked ? lastIdx : required;
      for (let i = 0; i < (contract.parcelas || []).length; i++) {
        const can = i <= lastIdx && contract.parcelas[i]?.selectable !== false;
        this.setParcelSelected(contract, i, can && i <= maxIdx);
      }
      this.normalizeSelection(contract);
    },

    toggleParcela(contract, idx) {
      if (!this.canToggleParcela(contract, idx)) {
        this.normalizeSelection(contract);
        return;
      }

      const lastIdx = this.lastSelectableIndex(contract);
      const target = contract.parcelas[idx];

      if (!target.selected) {
        for (let i = 0; i <= idx; i++) {
          if (contract.parcelas[i]?.selectable === false) break;
          this.setParcelSelected(contract, i, true);
        }
      } else {
        for (let i = idx; i <= lastIdx; i++)
          this.setParcelSelected(contract, i, false);
      }
      this.normalizeSelection(contract);
    },

    selectedCount(contract) {
      return (contract.parcelas || []).filter((p) => !!p.selected).length;
    },

    selectedTotal(contract) {
      const sum = (contract.parcelas || [])
        .filter((p) => !!p.selected)
        .reduce((acc, p) => acc + parseBR(p.valor), 0);
      return sum.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    isContractFullySelected(contract) {
      const lastIdx = this.lastSelectableIndex(contract);
      if (!contract?.parcelas || lastIdx < 0) return false;

      return contract.parcelas
        .slice(0, lastIdx + 1)
        .every((p) => p && p.selectable !== false && !!p.selected);
    },

    openContracts() {
      this.contracts.forEach((c) => {
        this.$set(this.openCombo, c.contrato, true);
        this.$set(this.openIndividual, c.contrato, true);
      });
      if ((this.contracts || []).some((c) => c && c.hasOffers === false && c.company === "TRICARD")) {
        this.openContractDetailsIndividual = true;
      }
    },

    formatBR(n) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(n || 0);
    },

    buildSelectionSnapshot(contracts) {
      const snap = {
        document: null,
        credor: null,
        company: null,
        installments: [],
        contracts: [],
      };

      for (const c of contracts || []) {
        const selected = (c.parcelas || []).filter((p) => p && p.selected);
        if (!selected.length) continue;

        if (!snap.document) {
          snap.document = String(c.regis);
          snap.credor = c.credor;
          snap.company = c.company;
        } else if (
          snap.document !== String(c.regis) ||
          snap.credor !== c.credor ||
          snap.company !== c.company
        ) {
          throw new Error(
            "Dados de cabeçalho divergentes entre contratos selecionados."
          );
        }

        const parcelasOffer = c?.offers?.[0]?.PARCELAS;

        if (Array.isArray(parcelasOffer)) {
          const start = parcelasOffer[0];
          const end = parcelasOffer[parcelasOffer.length - 1];
          snap.contracts.push({
            contract: c.contrato,
            startDueDateInstallment: start.VENCIMENTO,
            endDueDateInstallment: end.VENCIMENTO,
            startInstallmentNumber: start.PARCELA,
            endInstallmentNumber: end.PARCELA,
            updatedValue: end.PAGO,
            originalValue: end.PRINCIPAL,
            discountValue: c.discountValue,
            discountPercentage: c.discountPercentage,
            dueDate: end.VENCIMENTO,
            inCash: false,
          });
        } else if (parcelasOffer) {
          const inst = parcelasOffer;
          snap.contracts.push({
            contract: c.contrato,
            installmentNumber: inst.PARCELA,
            totalInstallments: c.parcelas.length,
            originalValue: inst.PRINCIPAL,
            updatedValue: inst.PAGO,
            discountValue: c.discountValue,
            discountPercentage: c.discountPercentage,
            dueDate: inst.VENCIMENTO,
            inCash: true,
          });
        }

        for (const p of selected) {
          snap.installments.push({
            contract: c.contrato,
            product: c.produto,
            dueInstallmentDate: this.toISO
              ? this.toISO(p.vencimento)
              : p.vencimento,
          });
        }
      }

      return snap;
    },

    buildAgreementPayload(
      snapshot,
      { dueDate, inputValue = "0", installmentNumber = "0", source = 1 } = {}
    ) {
      if (!snapshot || !snapshot.installments?.length)
        throw new Error("Nenhuma parcela selecionada.");
      if (!snapshot.document || !snapshot.credor || !snapshot.company)
        throw new Error("Cabeçalho incompleto para o payload.");

      const payload = {
        document: String(snapshot.document),
        credor: snapshot.credor,
        company: snapshot.company,
        inputValue: String(inputValue),
        installmentNumber: String(installmentNumber),
        installments: snapshot.installments,
        contracts: snapshot.contracts,
        dueDate: this.toISO(dueDate),
        source: Number(source) || 1,
      };

      if (!payload.dueDate)
        throw new Error("Data de vencimento do acordo inválida.");
      return payload;
    },

    buildAgreementPayloadTribanco(
      snapshot,
      {
        dueDate,
        inputValue = "0",
        installmentNumber = "0",
        source = 1,
        discountPercentage = null,
        targetContractId = null,
        contractIds = null,
      } = {}
    ) {
      if (!snapshot || !snapshot.installments?.length)
        throw new Error("Nenhuma parcela selecionada.");
      if (!snapshot.document || !snapshot.credor || !snapshot.company)
        throw new Error("Cabeçalho incompleto para o payload.");

      const due = this.toISO(dueDate);
      if (!due) throw new Error("Data de vencimento do acordo inválida.");

      const allowedIds = Array.isArray(contractIds)
        ? new Set(contractIds.map(String))
        : null;

      let installments = snapshot.installments;
      if (targetContractId) {
        installments = installments.filter((i) => i.contract === targetContractId);
      }
      if (allowedIds) {
        installments = installments.filter((i) =>
          allowedIds.has(String(i.contract))
        );
      }

      if (!installments.length)
        throw new Error("Nenhuma parcela selecionada neste contrato.");

      const payload = {
        document: String(snapshot.document),
        regis: String(snapshot.document),
        credor: snapshot.credor,
        company: snapshot.company,
        inputValue: String(inputValue),
        installmentNumber: String(installmentNumber),
        installments,
        dueDate: due,
        source: Number(source) || 1,
      };

      const uiContracts = [];

      for (const c of this.contracts || []) {
        if (targetContractId && c.contrato !== targetContractId) continue;
        if (allowedIds && !allowedIds.has(String(c.contrato))) continue;

        const idxs = (c.parcelas || [])
          .map((p, i) => (p?.selected ? i : -1))
          .filter((i) => i >= 0);

        if (!idxs.length) continue;

        const firstIdx = idxs[0];
        const lastIdx = idxs[idxs.length - 1];
        const totalSelected = idxs.length;

        const firstDue = this.toISO(c.parcelas[firstIdx]?.vencimento);
        const lastDue = this.toISO(c.parcelas[lastIdx]?.vencimento);

        const offer0 = Array.isArray(c.offers) ? c.offers[0] : null;
        const ret = offer0?.RETORNO || {};

        const selectedSum = idxs.reduce(
          (acc, i) => acc + parseBR(c.parcelas[i]?.valor),
          0
        );
        const selectedSumFormatted = selectedSum.toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        // Sem oferta (ex.: CAR/EMP): usa a soma das parcelas selecionadas.
        const originalValue =
          ret.PRINCIPAL ?? c.originalValue ?? selectedSumFormatted;
        const updatedValue =
          ret.VALORTOTAL ?? c.atSightOffer ?? selectedSumFormatted;
        const discountValue = ret.DESCONTO ?? c.discountValue ?? "0,00";
        const expenseValue =
          ret.VALORPARCELAR ?? c.updatedValue ?? selectedSumFormatted;
        const discountPerc =
          discountPercentage ?? c.discountPercentage ?? "0";

        uiContracts.push({
          contract: c.contrato,
          startInstallmentNumber: firstIdx + 1,
          endInstallmentNumber: lastIdx + 1,
          totalInstallments: totalSelected,

          startDueInstallmentDate: firstDue,
          endDueInstallmentDate: lastDue,

          originalValue,
          updatedValue,
          discountValue,
          expenseValue,
          discountPercentage: discountPerc,

          inCash: String(installmentNumber) === "0",
          dueDate: due,
        });
      }

      if (!uiContracts.length)
        throw new Error("Nenhuma parcela selecionada neste contrato.");

      payload.contracts = uiContracts;

      return payload;
    },

    toISO(dateStr) {
      if (!dateStr) return null;
      if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) return String(dateStr).slice(0, 10);
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
        const [dd, mm, yyyy] = dateStr.split("/");
        return `${yyyy}-${mm}-${dd}`;
      }
      const d = new Date(dateStr);
      if (Number.isNaN(+d)) return null;
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },

    autoSelectAll() {
      if (this.didAutoSelect) return;

      (this.contracts || []).forEach((c) => {
        this.toggleContrato(c, true);
      });

      this.syncSelectionFromContracts();

      this.didAutoSelect = true;
    },

    selectRadio(val) {
      this.inCashSelected = !!val;
    },

    moneyToNumber(val) {
      if (val === null || val === undefined) return 0;
      if (typeof val === "number") return Number.isFinite(val) ? val : 0;
      const s = String(val).trim();
      if (!s) return 0;
      // remove tudo que não é dígito, ponto, vírgula ou sinal
      const norm = s.replace(/[^\d,.]/g, "");
      // milhares '.' -> remove; decimal ',' -> vira '.'
      const num = parseFloat(norm.replace(/\./g, "").replace(",", "."));
      return Number.isFinite(num) ? num : 0;
    },

    hasPositiveMoney(val) {
      return this.moneyToNumber(val) > 0;
    },

    validateEmail(email) {
      if (!email) return false;
      const basic = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;
      if (!basic.test(String(email).trim())) return false;
      const [local, host] = String(email).trim().split("@");
      const domain = (host || "").split(".")[0] || "";
      // regra de negócio: exigir pelo menos 1 letra no local e no domínio
      return /[A-Za-z]/.test(local) && /[A-Za-z]/.test(domain);
    },

    validatePhoneBR(phone) {
      if (!phone) return false;
      const digits = String(phone).replace(/\D/g, "");
      // Brasil: 10 (fixo) ou 11 (celular) dígitos
      return digits.length === 10 || digits.length === 11;
    },

    validateInputsProposal() {
      // 1) Valor obrigatório conforme modo selecionado
      const hasValue = this.inCashSelected
        ? this.hasPositiveMoney(this.inCashValueProposal)
        : this.hasPositiveMoney(this.installmentValueProposal);

      // 2) Pelo menos UM contato válido (email OU telefone)
      const hasContact =
        this.validateEmail(this.newEmail) &&
        this.validatePhoneBR(this.newPhoneNumber);

      // 3) Respeitar limites e estados
      if (this.loading) return false;
      if (this.isBelowThan || this.isAboveThan) return false;

      return hasValue && hasContact;
    },

    organizeDatesSetYourProposal(debts) {
      const now = moment();
      const maximumDate = this.earliestMaximumDate(debts);
      const holidays = getBrazilianHolidays(now.year());

      let count = 0;

      while (count < 25) {
        if (maximumDate && now.isAfter(maximumDate)) {
          break;
        }

        if (isBusinessDay(now, holidays)) {
          this.dueDatesSetYourProposal.push(now.format("DD/MM/YYYY"));
          count++;
        }
        now.add(1, "day");
      }
      this.dueDateSetYourProposal = this.dueDatesSetYourProposal[0];
    },

    calculateDiscountPercentage(installment) {

      return (
        ((parseFloat(installment.RETORNO.DESCONTO.replace(/\./g, "").replace(",", ".")) -
          parseFloat(installment.RETORNO.JUROS.replace(/\./g, "").replace(",", "."))) /
          parseFloat(installment.RETORNO.VALORPARCELAR.replace(/\./g, "").replace(",", "."))) *
        100
      ).toFixed(2);
    },
  },
  mounted() {
    localStorage.removeItem("authUser");
  },
  async created() {
    this.loading = true;

    try {
      this.from = this.$route.params.from || null;
      // const forceFresh = this.from === "concluir";
      const forceFresh = true;

      this.ipUser = localStorage.getItem("ipUser") ?? "";
      this.userAdm = JSON.parse(localStorage.getItem("userAdm") || "null");
      this.largura = window.screen.width;

      if (forceFresh) {
        localStorage.removeItem("contracts");
        localStorage.removeItem("contractsInvoices");
      }

      let contractsFromLocalStorage = null;
      if (!forceFresh) {
        try {
          contractsFromLocalStorage = JSON.parse(
            localStorage.getItem("contracts") || "null"
          );
        } catch {
          contractsFromLocalStorage = null;
        }
      }

      let respContract = null;
      try {
        respContract =
          contractsFromLocalStorage ??
          (await this.ActionGetDebtsTribanco({
            UserID: this.userAdm ? this.userAdm.UserID : null,
            UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
            options: this.optionsInstallments,
            tag: localStorage.getItem("tag"),
            OS: navigator.platform,
            IP: this.ipUser,
            selection: null,
          }));
      } catch (error) {
        console.error("Erro ao buscar contratos:", error);
        respContract = [];
        this.contracts = [];
        this.contractsOriginal = [];
        this.agreements = [];
        this.showError?.(error?.message || "Erro ao carregar os contratos. Por favor, tente novamente.");
        this.loading = false;
        return;
      }

      console.log("respContract: " + JSON.stringify(respContract));

      // Normaliza: API pode retornar { results: [] } ou o array direto
      const debtsArray = Array.isArray(respContract)
        ? respContract
        : (respContract?.results ?? []);

      this.contractsOriginal = Array.isArray(debtsArray) ? debtsArray : [];
      this.contracts = [...this.contractsOriginal];
      //eslint-disable-next-line
      // debugger;

      if (this.contracts.length > 0) {
        this.populateDates(this.contracts);
        this.populateUnicaDueDate();
      } else {
        // Garante que agreements seja inicializado mesmo sem contratos
        if (!Array.isArray(this.agreements)) {
          this.agreements = [];
        }
      }

      // Só chama a rota de invoices se o retorno de debts não for vazio
      let respContractInvoices = null;
      if (debtsArray.length > 0) {
        if (!forceFresh) {
          try {
            respContractInvoices = JSON.parse(
              localStorage.getItem("contractsInvoices") || "null"
            );
          } catch {
            respContractInvoices = null;
          }
        }

        if (respContractInvoices == null) {
          try {
            respContractInvoices = await this.ActionGetInvoicesTribanco({
              IP: this.ipUser || "",
              OS: navigator.platform,
            });
          } catch (e) {
            console.warn("Falha ao obter invoices:", e?.message || e);
            respContractInvoices = null;
          }
        }
      }

      this.contractsInvoices = [];
      if (respContractInvoices != null) {
        // Se a resposta tem results, usar results diretamente
        if (respContractInvoices.results) {
          this.contractsInvoices = [respContractInvoices];
        } else if (Array.isArray(respContractInvoices)) {
          this.contractsInvoices = respContractInvoices;
        } else {
          this.contractsInvoices = [respContractInvoices];
        }
      }

      try {
        localStorage.setItem("contracts", JSON.stringify(this.contracts));
        localStorage.setItem(
          "contractsInvoices",
          JSON.stringify(this.contractsInvoices)
        );
      } catch (e) {
        this.showError?.(e.message, "Falha ao carregar dados invoices.");
      }

      this.rulesClient();

      // Transformar invoices em agreements se houver invoices (só se debts não for vazio)
      if (debtsArray.length > 0) {
        await this.loadInvoicesAsAgreements();
      }

      (this.contracts || []).forEach((c) =>
        (c.parcelas || []).forEach((p) => {
          if (!("selected" in p)) this.$set(p, "selected", false);
        })
      );
      (this.contracts || []).forEach((c) => {
        if (!Array.isArray(c.offers)) this.$set(c, "offers", []);
      });

      // Se não houver contratos mas houver agreements (incluindo invoices), redirecionar para meusAcordos
      // Mas apenas uma vez por sessão (primeira carga ou refresh), não quando vier de navegação manual
      const hasAutoRedirected = sessionStorage.getItem("autoRedirectToAcordos") === "true";
      const userChosePropostas = sessionStorage.getItem("userChosePropostas") === "true";
      const isManualNavigation = this.from === "meusAcordos";
      
      if (
        this.contracts.length === 0 && 
        this.agreements && 
        this.agreements.length > 0 &&
        !hasAutoRedirected &&
        !isManualNavigation &&
        !userChosePropostas
      ) {
        this.isRedirectingToAcordos = true;
        sessionStorage.setItem("autoRedirectToAcordos", "true");
        await this.$router.push({ name: "meusAcordos" });
        return;
      }

      if (this.contracts.length > 0) {
        this.openContracts();
        this.organizeDatesSetYourProposal(this.contracts);
      }
      this.loading = false;
    } catch (e) {
      this.showError?.(e.message || "Falha ao carregar dados.");
      this.loading = false;
    } finally {
      this.loading = false;
    }
  },

  computed: {
    ...mapState("auth", ["user"]),
    isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },

    contractsTribanco() {
      return (this.contracts || []).filter((c) => !this.isUnicaContract(c));
    },
    contractsUnica() {
      return (this.contracts || []).filter((c) => this.isUnicaContract(c));
    },
    unicaSelectedCount() {
      return (this.contractsUnica || []).filter((c) =>
        this.isUnicaContractSelected(c)
      ).length;
    },
    unicaSelectedTotal() {
      const total = (this.contractsUnica || [])
        .filter((c) => this.isUnicaContractSelected(c))
        .reduce((acc, c) => acc + this.parseBR(this.unicaContractValue(c)), 0);
      return total.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    contractFullSelectedMap() {
      const map = {};
      (this.contracts || []).forEach((c) => {
        map[c.contrato] = this.isContractFullySelected(c);
      });
      return map;
    },
    // opcional: todos os contratos 100% selecionados
    allContractsFullySelected() {
      const cs = this.contracts || [];
      return (
        cs.length > 0 &&
        cs.every((c) => this.contractFullSelectedMap[c.contrato])
      );
    },
  },
};
</script>
<style scoped>
.alert-flashing {
  animation: alert-flash 0.5s infinite alternate;
  width: 100%;
}

@keyframes alert-flash {
  0% {
    background-color: #e7ebfd;
    color: #0046c0;
  }

  100% {
    background-color: #a2b1d8;
  }
}

.linklike {
  background: none;
  border: 0;
  padding: 0;
  color: #0d6efd;
  text-decoration: underline;
  cursor: pointer;
}

.linklike:disabled {
  color: #6c757d;
  text-decoration: none;
  cursor: not-allowed;
}

.emp-total {
  font-size: 0.95rem;
  color: #333;
}

.emp-total strong {
  color: #0b1f66;
}

.unica-divider {
  margin: 12px 0;
  border-top: 1px solid #e1e1e4;
}

.unica-select {
  display: block;
  background: #eff0f2;
  padding: 8px;
}

.unica-select-caption {
  margin: 0 0 10px;
  color: #3a4148;
  font-size: 10px;
  font-weight: 400;
  line-height: 1.2;
}

.unica-table {
  display: grid;
  grid-template-columns: 27px minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.1fr);
  column-gap: 8px;
  row-gap: 6px;
  align-items: center;
}

.unica-head,
.unica-cell {
  color: #3a4148;
  font-size: 10px;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
}

.unica-head {
  font-weight: 700;
  min-height: 12px;
}

.unica-cell {
  font-weight: 400;
}

.unica-check {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  cursor: pointer;
}

.unica-check input {
  display: none;
}

.unica-check span {
  position: relative;
  width: 18px;
  height: 18px;
  border: 1px solid #b5bcc4;
  border-radius: 2px;
  background: #fff;
}

.unica-check input:checked + span {
  border-color: #2563eb;
  background: #2563eb;
}

.unica-check input:checked + span::after {
  content: "";
  position: absolute;
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
</style>